import * as moment from 'moment';
import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import {
  ConfiguracionFormulario,
  TipoCampoFormulario,
  PosicionLabelFormulario,
  OpcionCampo,
} from 'src/app/compartido/formulario/utilidades/formulario.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { formatearFecha } from 'src/app/compartido/utilidades/valores.utils';

/* Configuración de la ficha de preparar orden */
export const CONFIGURACION_FICHA_PREPARAR_ORDEN: ConfiguracionFicha = {
  header: { titulo: 'Preparar Orden', icono: Icono.PREPARACION },
  contenido: { padding: true },
  maxWidth: 900,
};

/* Acciones de preparar orden */
export enum AccionPrepararOrden {
  PREPARAR = 'preparar',
  PREPARAR_PARCIAL = 'preparar_parcial',
  APLAZAR = 'aplazar',
  RECHAZAR = 'rechazar',
}

/* Configuración del formulario de preparar orden */
export const CONFIGURACION_FORMULARIO_PREPARAR_ORDEN: ConfiguracionFormulario =
  {
    campos: [
      {
        nombre: 'Accion',
        slug: 'accion',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [
          { nombre: 'Preparar', valor: AccionPrepararOrden.PREPARAR },
          {
            nombre: 'Preparar Parcialmente',
            valor: AccionPrepararOrden.PREPARAR_PARCIAL,
          },
          {
            nombre: 'Aplazar Preparación',
            valor: AccionPrepararOrden.APLAZAR,
          },
          { nombre: 'Rechazar', valor: AccionPrepararOrden.RECHAZAR },
        ],
        requerido: true,
      },
      {
        nombre: 'Aplazar Hasta',
        slug: 'aplazar_hasta',
        tipo: TipoCampoFormulario.FECHA,
        minimo: formatearFecha(moment().add(1, 'days')),
        oculto: true,
      },
      {
        nombre: 'Motivo',
        slug: 'motivo',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [],
        oculto: true,
      },
      {
        nombre: 'Observación',
        slug: 'observacion',
        tipo: TipoCampoFormulario.TEXTO,
        oculto: true,
      },
    ],
    estilo: {
      widthCampo: 250,
      widthLabel: 250,
      posicionLabel: PosicionLabelFormulario.TOP,
      marcarRequeridos: true,
    },
  };

/* Opciones de motivo de aplazar */
export const OPCIONES_MOTIVO_APLAZAR: OpcionCampo<string>[] = [
  {
    nombre: 'Falta de inventario',
    valor: 'Falta de inventario',
    extra:
      'Los medicamentos solicitados no están disponibles en nuestro inventario en este momento, tu solicitud será pospuesta hasta que se reponga el stock',
  },
  {
    nombre: 'Vigencia de la fórmula',
    valor: 'Vigencia de la fórmula',
    extra:
      'La fórmula médica tiene una fecha de vigencia que aún no ha llegado, tu solicitud será pospuesta hasta que la fórmula sea válida',
  },
  { nombre: 'Otro', valor: 'Otro' },
];

/* Opciones de motivo de rechazo */
export const OPCIONES_MOTIVO_RECHAZO: OpcionCampo<string>[] = [
  {
    nombre: 'Fórmula no legible',
    valor: 'Fórmula no legible',
    extra:
      'La fórmula médica no es clara o está borrosa, lo que impide verificar los datos necesarios para procesar la solicitud',
  },
  {
    nombre: 'Fórmula vencida',
    valor: 'Fórmula vencida',
    extra:
      'La fórmula médica ha excedido la fecha de vigencia permitida para su uso',
  },
  {
    nombre: 'Orden duplicada',
    valor: 'Orden duplicada',
    extra:
      'La fórmula que has cargado ya está siendo procesada en otra orden y está pendiente de entrega',
  },
  {
    nombre: 'Fórmula incompleta',
    valor: 'Fórmula incompleta',
    extra:
      'La fórmula médica no incluye información necesaria como dosis, frecuencia o indicaciones claras, lo que imposibilita su procesamiento',
  },
  {
    nombre: 'Incongruencia en los datos de la fórmula',
    valor: 'Incongruencia en los datos de la fórmula',
    extra:
      'Los datos registrados en la fórmula médica (como nombre o cédula) no coinciden con los del usuario que realiza la solicitud',
  },
  {
    nombre: 'Error en el archivo adjunto',
    valor: 'Error en el archivo adjunto',
    extra:
      'El archivo adjunto no corresponde a una fórmula médica, está dañado, no se puede abrir o no cumple con los requisitos (por ejemplo, no está en formato PDF)',
  },
  { nombre: 'Otro', valor: 'Otro' },
];

/* Configuración del formulario de preparar orden con domicilio */
export const CONFIGURACION_FORMULARIO_PREPARAR_CON_DOMICILIO: ConfiguracionFormulario =
  {
    campos: [
      {
        nombre: '¿Crear un domicilio para la orden?',
        slug: 'crear',
        tipo: TipoCampoFormulario.BOOLEANO,
        requerido: true,
      },
      {
        nombre: 'Motivo',
        slug: 'motivo',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [
          {
            nombre: 'Entregado por ventanilla',
            valor: 'Entregado por ventanilla',
          },
          {
            nombre: 'Re-creada con nueva fórmula',
            valor: 'Re-creada con nueva fórmula',
          },
          { nombre: 'Otro', valor: 'Otro' },
        ],
        oculto: true,
      },
      {
        nombre: 'Recaudo',
        slug: 'recaudo',
        tipo: TipoCampoFormulario.NUMERO,
        minimo: 0,
        valor: 0,
        prefijo: '$',
        oculto: true,
      },
    ],
    estilo: {
      widthCampo: 250,
      widthLabel: 250,
      posicionLabel: PosicionLabelFormulario.TOP,
      marcarRequeridos: true,
    },
  };
